import styled from "styled-components";
import { Grid } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";

export const GreyCircleButton = styled.div`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #dadada;
  margin-right: 5px;
  margin-bottom: 8px;
  text-align: center;
  line-height: 100%;
  color: #fff;
  font-size: 2.5rem;
  cursor: pointer;
  &:hover {
    background-color: #bfbfbf;
  }
`;

export const StyledEventCard = styled.div`
  background-color: #fff;
  border-radius: 10px;
  box-shadow: rgba(0, 0, 0, 0.3) 0px 7px 9px;
  padding: 1rem;
  margin: 0rem 1rem 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const MainContainer = styled.div`
  width: 100%;
  background-color: #fff;
`;

export const HeaderContainer = styled.div`
  width: 100%;
  padding: 0px 2rem 1rem;
  box-sizing: border-box;
`;

export const BackButtonContainer = styled.div`
  margin-bottom: 1rem;
`;

export const ProjectTitle = styled.h1`
  font-size: 2rem;
  font-weight: 700;
  margin: 0;
`;

export const TimeRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
  margin: 0.5rem 0;
`;

export const TimeIcon = styled(AccessTimeIcon)`
  font-size: 18px !important;
  color: #fe2f67;
`;

export const ProjectDate = styled.span`
  font-size: 0.9rem;
  font-weight: 700;
  color: #fe2f67;
`;

export const ProjectDescription = styled.p`
  font-size: 1rem;
  color: #606770;
  margin: 0;
  margin-bottom: 1rem;
`;
export const ColumnsContainer = styled.div`
  margin: 0 auto;
  padding: 0 1rem;

  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  box-sizing: border-box;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }

  @media (min-width: 1024px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

export const ColumnBlock = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SectionHeader = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 1rem 0.5rem;
  align-items: flex-start;
`;

export const SectionTitle = styled.h2`
  display: inline-block;
  width: auto;
  font-size: 1rem;
  font-weight: 700;
  border-bottom: 3px solid #fe2f67;
  margin: 0;
  padding-bottom: 2px;
`;

export const AddButtonImage = styled.img`
  align-self: flex-end;
  margin-top: 0.5rem;
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
export const SectionContent = styled.div`
  background-color: #f6f4f4;
  border-radius: 10px;
  width: 100%;
`;

export const SubSectionTitle = styled.p`
  font-size: 0.9rem;
  font-weight: 600;
  color: #606770;
  padding: 1rem;
`;
export const PlaceholderBox = styled.div`
  background-color: #f6f4f4;
  height: 12rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SeeAllLink = styled.span`
  font-size: 0.9rem;
  color: #fe2f67;
  text-decoration: underline;
  cursor: pointer;
  font-weight: 600;
`;

export const PostersContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
`;

export const PosterCard = styled.div`
  width: 100%;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
`;

export const PosterImage = styled.img`
  width: 100%;
  height: 120px;
  object-fit: cover;
`;

export const PosterCaption = styled.p`
  font-size: 0.8rem;
  margin: 0.5rem;
  color: #000;
`;

export const CardItem = styled.div`
  background-color: #fff;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 0.5rem;
`;

export const EventCardContainer = styled.div`
  display: flex;
  background-color: #fff;
`;

export const EventInfoContainer = styled.div`
  margin-left: 1rem;
  display: flex;
  flex-direction: column;
`;

export const EventTitle = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin: 0;
`;

export const EventInfoRow = styled.div`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  margin-top: 0.2rem;
`;

export const EventInfoText = styled.p`
  font-size: 12px;
  margin: 0;
  color: #606770;
`;

export const FundraisingCardContainer = styled.div`
  background-color: #f6f4f4;
  border-radius: 10px;
  height: 16rem;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 0.5rem;
  padding: 1rem;
  box-sizing: border-box;
`;

export const PosterImageFallback = styled.div`
  width: 100%;
  height: 120px;
  background-color: #f0f0f0;
  color: #999;
  font-style: italic;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  object-fit: cover;
`;
